import axios from 'axios';
import config from '../config'; // Ensure you have an API base URL in your config file

const NotificationService = {
  /**
   * Fetch all notifications for the authenticated user.
   * @returns {Promise} A promise that resolves to the list of all notifications.
   */
  getAllNotifications: async () => {
    try {
      const response = await axios.get(`${config.apiBaseUrl}/notifications`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all notifications:', error);
      throw error;
    }
  },

  /**
   * Fetch unread notifications for the authenticated user.
   * @returns {Promise} A promise that resolves to the list of unread notifications.
   */
  getUnreadNotifications: async () => {
    try {
      const response = await axios.get(`${config.apiBaseUrl}/notifications/unread`);
      return response.data;
    } catch (error) {
      console.error('Error fetching unread notifications:', error);
      throw error;
    }
  },

  /**
   * Mark all notifications as read for the authenticated user.
   * @returns {Promise} A promise that resolves to a success message.
   */
  markAllAsRead: async () => {
    try {
      const response = await axios.post(`${config.apiBaseUrl}/notifications/mark-all-read`);
      return response.data;
    } catch (error) {
      console.error('Error marking notifications as read:', error);
      throw error;
    }
  },
};

export default NotificationService;
